<!-- Copyright (c) 2022-2024, NVIDIA CORPORATION & AFFILIATES. All rights reserved. -->

<template>
    <form id="dropzone" class="dropzone"></form>
</template>
<script>
import Dropzone from 'dropzone';

Dropzone.autoDiscover = false;

export default {
    name: 'Dropzone',

    props: {
        acceptedFiles: {
            default: undefined,
            type: [String, undefined],
        },
        placeholder: {
            default: undefined,
            type: [String, undefined],
        },
    },

    mounted() {
        this.configureDropzone();
    },

    methods: {
        configureDropzone() {
            const $vm = this;
            this.dropzone = new Dropzone('form#dropzone', {
                init: function init() {
                    this.on('addedfile', function addedFile(file) {
                        $vm.$emit('addedFile', file.name);
                        this.emit('thumbnail', file, 'images/document_confirm.png');
                    });
                    this.on('error', () => {
                        $vm.$emit('error');
                    });
                    this.on('maxfilesexceeded', function maxFiles(file) {
                        this.removeFile(file);
                    });
                    this.on('success', (_, res) => {
                        $vm.$emit('uploadSuccess', res);
                    });
                },
                acceptedFiles: this.acceptedFiles,
                createImageThumbnails: false,
                dictDefaultMessage: this.placeholder,
                headers: this.headers,
                maxFiles: 1,
                url: `${window.airschipp.api}/v1/migrate`,
            });
        },
    },

    computed: {
        headers() {
            const headersObj = {};
            try {
                const token = JSON.parse(localStorage.getItem('token'));
                if (token) {
                    headersObj.Authorization = `Bearer ${token}`;
                }
                const username = JSON.parse(localStorage.getItem('username'));
                if (username) {
                    headersObj['X-Air-Username'] = username;
                }
            } catch (err) {
                console.warn(err);
            }
            return headersObj;
        },
    },
};
</script>
<style lang="scss">
@import '~@cumulus/air-ui-kit/variables.scss';

#dropzone {
  cursor: pointer;
  border: dashed 5px;
  border-color: #E1E2E4;
  box-shadow: 2px 2px 10px 2px rgba(181, 189, 201, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-color: white;

  .dz-button {
    border: unset;
    background-color: unset;
    color: $text-primary;
    text-transform: unset;
  }

  .dz-error-mark {
      display: none;
  }

  .dz-error-message {
      display: none;
  }

  &.dz-max-files-reached {
    cursor: default;
    pointer-events: none;
  }

  .dz-image img {
      height: 72px;
  }

  .dz-message {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      text-align: center;
      width: 100%;
  }

  .dz-success-mark {
      display: none;
  }

  &.dz-started { // file added
    background-color: unset;
    border: unset;
    box-shadow: unset;
    align-items: unset;
    height: unset;

    .dz-message {
        display: none;
    }
  }

  .dz-preview {
      margin-top: 30px;
  }

  .dz-icon {
      font-size: 72px;
      margin: 25px;
      color: #B5BDC9;
  }
}
</style>
